import React from "react";

const Loader = () => {
  return (
    <div className="flex justify-center mt-10">
      <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10 opacity-90"></div>
    </div>
  );
};

export default Loader;
